import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "o-text-body font-bold text-10 md:text-12 lg:text-14" }
const _hoisted_2 = {
  key: 0,
  class: "o-text-caption hidden truncate md:block"
}

import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import { computed } from 'vue';
import dictionaryService from '@/core/dictionary/dictionary.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSpotTitle',
  props: {
    designer: null,
    name: null
  },
  setup(__props: any) {

const props = __props as {
    designer?: string;
    name: string;
}




const globalLabels = useGlobalLabels(GlobalLabels.product);

const designerLabel = computed(() => {
    return dictionaryService.formatNamed(globalLabels.designedBy, { designer: props.designer ?? '' });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(__props.name), 1),
    (__props.designer)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(designerLabel)), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})